<template>
  <div id="scroll-anchor"></div>
</template>

<style scoped lang="scss">
#scroll-anchor {
  @apply absolute h-0 w-0;
  @apply max-md:top-[-80px]; // mobile;
  @apply md:max-lg:top-[-300px]; // tablet;
  @apply lg:top-[-270px]; // desktop;
}
</style>
